import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@/hooks/useTheme";
import { Settings, User } from "lucide-react";

export function Header() {
  const { isDark } = useTheme();
  const navigate = useNavigate();
  const [logoError, setLogoError] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-white/80 dark:bg-[#0D1117]/90 backdrop-blur-xl border-b border-gray-100 dark:border-[#1E3A5F]">
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#06B6D4]/10 via-transparent to-[#2563EB]/10 pointer-events-none" />

      <div className="relative flex h-14 items-center justify-between px-4">
        {/* Logo */}
        <div className="flex items-center gap-2">
          {!logoError ? (
            <img
              src={isDark ? "/logo-dark.svg" : "/logo-light.svg"}
              alt="VajraSila"
              className="h-8 w-auto"
              onError={() => setLogoError(true)}
            />
          ) : (
            <div className="flex items-center gap-2">
              <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-gradient-to-br from-vajra-blue to-vajra-cyan">
                <span className="text-sm font-bold text-white">VS</span>
              </div>
              <span className="text-lg font-semibold tracking-tight bg-gradient-to-r from-[#2563EB] to-[#06B6D4] bg-clip-text text-transparent">
                VajraSila
              </span>
            </div>
          )}
        </div>

        {/* Right side icons */}
        <div className="flex items-center gap-1">
          <button
            type="button"
            onClick={() => navigate("/profile")}
            className="flex h-9 w-9 items-center justify-center rounded-lg text-gray-400 dark:text-muted-foreground hover:text-gray-700 dark:hover:text-foreground hover:bg-gray-100 dark:hover:bg-white/5 transition-colors"
            aria-label="Profil"
          >
            <User className="h-5 w-5" />
          </button>
          <button
            type="button"
            onClick={() => navigate("/settings")}
            className="flex h-9 w-9 items-center justify-center rounded-lg text-gray-400 dark:text-muted-foreground hover:text-gray-700 dark:hover:text-foreground hover:bg-gray-100 dark:hover:bg-white/5 transition-colors"
            aria-label="Einstellungen"
          >
            <Settings className="h-5 w-5" />
          </button>
        </div>
      </div>
    </header>
  );
}
